import type { HandbookDocument } from './handbookTypes';

const BASE_URL = import.meta.env.VITE_STUDIO_API_BASE_URL || 'http://localhost:8087';

/** The API refused this person the handbook: signed out (401) or without Handbook Access (403). */
export class HandbookAccessError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'HandbookAccessError';
    this.status = status;
  }
}

/** The whole handbook, which the API gives only to Handbook readers and platform admins. */
export async function fetchHandbook(token: string | undefined): Promise<HandbookDocument> {
  const response = await fetch(`${BASE_URL}/api/handbook`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    cache: 'no-store',
  });
  if (response.status === 401 || response.status === 403) {
    const body = (await response.json().catch(() => ({}))) as { error?: unknown };
    throw new HandbookAccessError(response.status, typeof body.error === 'string' ? body.error : 'You do not have access to the Studio Handbook');
  }
  if (!response.ok) throw new Error(`The Studio Handbook could not be loaded (${response.status})`);
  return (await response.json()) as HandbookDocument;
}
